import type { Word } from '../../../common/schema/schemaType'

export const wordsMem: Record<string, Word> = {
  'hello': {
    id: 'hello',
    word: 'hello',
    phonetic: '/həˈloʊ/',
    definitions: [
      { partOfSpeech: 'interj.', meaning: '你好;喂' },
      { partOfSpeech: 'n.', meaning: '招呼;问候' },
      { partOfSpeech: 'v.', meaning: '打招呼;问好' }
    ],
    examples: [
      { english: 'Hello, how are you?', chinese: '你好,你好吗?' },
      { english: 'She said hello to me when I arrived.', chinese: '我到达时她向我打招呼。' }
    ]
  },
  'world': {
    id: 'world',
    word: 'world',
    phonetic: '/wɜːrld/',
    definitions: [
      { partOfSpeech: 'n.', meaning: '世界;地球;领域' }
    ],
    examples: [
      { english: 'Travel around the world.', chinese: '环游世界。' },
      { english: 'The world of science is fascinating.', chinese: '科学世界令人着迷。' }
    ]
  },
  'dictionary': {
    id: 'dictionary',
    word: 'dictionary',
    phonetic: '/ˈdɪkʃəneri/',
    definitions: [
      { partOfSpeech: 'n.', meaning: '词典;字典' }
    ],
    examples: [
      { english: 'Look it up in the dictionary.', chinese: '在字典里查一下。' },
      { english: 'This dictionary has over 50,000 entries.', chinese: '这本词典有超过5万个词条。' }
    ]
  },
  'learn': {
    id: 'learn',
    word: 'learn',
    phonetic: '/lɜːrn/',
    definitions: [
      { partOfSpeech: 'v.', meaning: '学习;学会;得知' }
    ],
    examples: [
      { english: 'I want to learn English.', chinese: '我想学英语。' },
      { english: 'We learn from our mistakes.', chinese: '我们从错误中学习。' }
    ]
  },
  'study': {
    id: 'study',
    word: 'study',
    phonetic: '/ˈstʌdi/',
    definitions: [
      { partOfSpeech: 'v.', meaning: '学习;研究' },
      { partOfSpeech: 'n.', meaning: '研究;学习;书房' }
    ],
    examples: [
      { english: 'I study hard every day.', chinese: '我每天努力学习。' },
      { english: 'This study shows interesting results.', chinese: '这项研究显示出有趣的结果。' }
    ]
  },
  'book': {
    id: 'book',
    word: 'book',
    phonetic: '/bʊk/',
    definitions: [
      { partOfSpeech: 'n.', meaning: '书;书籍' },
      { partOfSpeech: 'v.', meaning: '预订;预约' }
    ],
    examples: [
      { english: 'I am reading a book.', chinese: '我在读一本书。' },
      { english: 'Book a table for two.', chinese: '预订两人的桌位。' }
    ]
  },
  'language': {
    id: 'language',
    word: 'language',
    phonetic: '/ˈlæŋɡwɪdʒ/',
    definitions: [
      { partOfSpeech: 'n.', meaning: '语言;表达方式' }
    ],
    examples: [
      { english: 'English is a global language.', chinese: '英语是一门全球性语言。' },
      { english: 'Body language is important.', chinese: '肢体语言很重要。' }
    ]
  },
  'word': {
    id: 'word',
    word: 'word',
    phonetic: '/wɜːrd/',
    definitions: [
      { partOfSpeech: 'n.', meaning: '单词;词;话' }
    ],
    examples: [
      { english: 'What does this word mean?', chinese: '这个单词是什么意思?' },
      { english: 'Keep your word.', chinese: '信守诺言。' }
    ]
  }
}
